
import {
  Vue, Component, Mixins, Watch,
} from 'vue-property-decorator';
import UpdateButton from '@/components/UpdateButton.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import Editor from '@/components/Editor.vue';
import AssignmentEntryItem from '@/components/AssignmentEntryItem.vue';
import OperationAssignmentsDialog from '@/components/OperationAssignmentsDialog.vue';
import { BoxStatusType, User, AssignmentEntry } from '@/types';
import {
  getLeadCustomValue,
  getLeadCustomValueText, getLeadCustomValueDate,
} from '@/helpers';

import UtilsMixin from '@/mixins/UtilsMixin.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';

@Component({
  components: {
    UpdateButton,
    AttachmentWithStatus,
    Editor,
    AssignmentEntryItem,
    OperationAssignmentsDialog,
  },
})
export default class EditDoganeDialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  doganeElettricoNotes: string | null = null

  praticaDogane: BoxStatusType = 'todo'

  // Dogane assignment
  doganeAssigneeId: number | null = null
  doganeAssigned: string | null = null
  doganeAssignedDate: Date | null = null
  doganeAssignees: string | null = null
  editDoganeAssignmentDialog = false

  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    this.praticaDogane = (this.connection?.praticaDogane ?? 'todo') as BoxStatusType;

    if (this.currentElettricaFiglia) {
      this.doganeElettricoNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'doganeElettricoNotes') ?? null;
    }

    this.refreshDoganeAssignment();
    const assignmentTypes = this.$store.getters.getAssignmentTypes || [];
    if (assignmentTypes.length === 0) {
      this.$store.dispatch('fetchAssignmentTypes');
    }

    return this.mixinRefresh();
  }

  onFieldUpdated(field: string, value: unknown = undefined) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    if (value !== undefined) this[field] = value;

    const update = {} as { [key: string]: unknown };

    update[field] = this[field] ?? '';

    const form = this.getForm();
    if (form) form.validate();

    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });

    return this.mixinOnFieldUpdated(field, value);
  }

  onNotesUpdated(field: string) {
    return this.mixinOnFieldUpdated(field);
  }

  getForm(): (Vue & { validate: () => boolean; reset: () => boolean }) | undefined {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  get users(): User[] {
    return this.$store.getters.users;
  }

  get doganeAssigneeName(): string | null {
    if (!this.doganeAssigneeId) return null;
    const user = this.users.find((u) => u.id === this.doganeAssigneeId);
    return user?.name ?? null;
  }

  get doganeEntry(): AssignmentEntry {
    const config = this.$store.getters.getAssignmentType('dogane');
    return {
      type: 'dogane',
      label: config?.label || 'Assegnatario Dogane',
      icon: config?.icon || 'mdi-truck-fast-outline',
      dateTooltip: 'Data assegnazione Dogane',
      permissionShow: 'doganeAssignment.show',
      permissionEdit: 'doganeAssignment.edit',
      multipleAssignees: false,
      assignees: [],
      assigneeId: this.doganeAssigneeId,
      assigneeName: this.doganeAssigneeName,
      assigned: this.doganeAssigned,
      assignedDate: this.doganeAssignedDate,
    };
  }

  get doganeAssignmentOperation(): Record<string, unknown> | null {
    const child = this.currentElettricaFiglia;
    if (!child) return null;
    return {
      children: {
        [child.id]: {
          type: 'elettrica-figlia',
          doganeAssigneeId: this.doganeAssigneeId,
          doganeAssigned: this.doganeAssigned,
          doganeAssignedDate: this.doganeAssignedDate,
          doganeAssignees: this.doganeAssignees,
          firstTaskId: child.Tasks?.[0]?.id || null,
        },
      },
    };
  }

  onEditDoganeAssignment() {
    if (!this.hasPermission('doganeAssignment.edit')) return;
    if (this.fieldsDisabled) return;
    this.editDoganeAssignmentDialog = true;
  }

  @Watch('currentElettricaFiglia')
  onElettricaFigliaChange() {
    this.doganeElettricoNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'doganeElettricoNotes') ?? null;
    this.refreshDoganeAssignment();
  }

  @Watch('editDoganeAssignmentDialog')
  onEditDoganeAssignmentDialogChange(val: boolean) {
    if (!val) {
      this.refreshDoganeAssignment();
    }
  }

  refreshDoganeAssignment() {
    const child = this.currentElettricaFiglia;
    if (!child) return;
    const childAny = child as unknown as Record<string, unknown>;
    const doganeFromTopLevel = 'doganeAssigneeId' in childAny || 'doganeAssigned' in childAny;
    const doganeAssigneeCV = getLeadCustomValue(child, 'doganeAssignee');
    this.doganeAssigneeId = doganeFromTopLevel && childAny.doganeAssigneeId != null
      ? Number(childAny.doganeAssigneeId)
      : (doganeAssigneeCV?.userValueId ?? null);
    this.doganeAssigned = (doganeFromTopLevel && childAny.doganeAssigned != null
      ? childAny.doganeAssigned
      : (getLeadCustomValueText(child, 'doganeAssigned') ?? 'todo')) as string;
    this.doganeAssignedDate = doganeFromTopLevel && childAny.doganeAssignedDate != null
      ? (childAny.doganeAssignedDate as Date)
      : getLeadCustomValueDate(child, 'doganeAssignedDate');
    this.doganeAssignees = getLeadCustomValueText(child, 'doganeAssignees') ?? '[]';
  }
}
